import { create } from 'zustand';

import { Nullable, Rubro } from '@/shared/interfaces';

interface RecaudacionesStore {
  currentRubro: Nullable<Rubro>;

  setCurrentRubro: (rubro: Nullable<Rubro>) => void;
}

export const useRecaudacionesStore = create<RecaudacionesStore>(set => ({
  currentRubro: null,

  setCurrentRubro: rubro => set({ currentRubro: rubro }),
}));
